module.exports = __webpack_public_path__ + "static/sp-86c4899bf8b01664870df75ed303e9c1.jpg";